/* Raw Water Co. v2 — mobile nav toggle (hamburger). */
(function () {
  function init(header) {
    if (header.dataset.v2Init) return;
    header.dataset.v2Init = "1";
    var burger = header.querySelector("[data-v2-burger]");
    var nav = header.querySelector("[data-v2-mobile-nav]");
    if (!burger || !nav) return;

    function setOpen(open) {
      header.classList.toggle("v2-header--open", open);
      burger.setAttribute("aria-expanded", open ? "true" : "false");
      nav.hidden = !open;
    }

    burger.addEventListener("click", function () {
      setOpen(burger.getAttribute("aria-expanded") !== "true");
    });

    // Close when a link is tapped, on Escape, or when resizing up to desktop.
    nav.addEventListener("click", function (e) {
      if (e.target.closest("a")) setOpen(false);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") setOpen(false);
    });
    window.addEventListener("resize", function () {
      if (window.innerWidth > 768) setOpen(false);
    });
  }

  function initAll() { document.querySelectorAll("[data-v2-header]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initAll);
  else initAll();
  document.addEventListener("shopify:section:load", initAll);
})();
